import { render, staticRenderFns } from "./DarkDesign.vue?vue&type=template&id=614901ce&scoped=true&"
import script from "./DarkDesign.vue?vue&type=script&lang=js&"
export * from "./DarkDesign.vue?vue&type=script&lang=js&"
import style0 from "./DarkDesign.vue?vue&type=style&index=0&id=614901ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614901ce",
  null
  
)

export default component.exports